import React, { useState, useEffect } from 'react';
import { Form, Button, Modal } from '@themesberg/react-bootstrap';
import axiosInstance from "../../../api/api";
import ReactQuill, { Quill } from 'react-quill';
import 'quill/dist/quill.snow.css';

const CreateForm = ({ optionId,onAdd }) => {
    const [show, setShow] = useState(false); // Estado para controlar la visibilidad del modal
    const [formData, setFormData] = useState({
        description: "",
        value: "",
        type: "",
        tooltip: "",
        modal: "",
        link: "",
        option: optionId,
    });


    // Manejar cambios en los campos del formulario
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleModal = (value) => {
        setFormData({
            ...formData,
            ["modal"]: value,
        });
    };

    const handleTooltip = (value) => {
        setFormData({
            ...formData,
            ["tooltip"]: value,
        });
    };

    // Manejar el envío del formulario
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.description || !formData.value) {
            alert('Por favor, completa todos los campos.');
            return;
        }

        try {
            // Hacer la solicitud POST al web service
            const response = await axiosInstance.post('/detailoption/', formData);
            console.log('Respuesta del servidor:', response.data);

            // Si el servidor responde con éxito, llamar a la función onAdd
            onAdd();

            // Limpiar el formulario y cerrar el modal
            setFormData({ description: "",
                value: "",
                type: "",
                tooltip: "",
                modal: "",
                link: "",});

            setShow(false);
        } catch (error) {
            console.error('Error al enviar los datos:', error);
            alert('Hubo un error al enviar los datos. Por favor, intenta nuevamente.');
        }
    };

    return (
        <>
            <Button variant="primary" size={"sm"} onClick={() => setShow(true)}>
                Agregar Registro
            </Button>

            <Modal show={show} onHide={() => setShow(false)} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Agregar Nuevo Registro</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="formDescription">
                            <Form.Label>Description</Form.Label>
                            <Form.Control
                                type="text"
                                name="description"
                                value={formData.description}
                                onChange={handleChange}
                                required
                            />
                        </Form.Group>

                        <Form.Group controlId="formValue">
                            <Form.Label>Value</Form.Label>
                            <Form.Control
                                type="text"
                                name="value"
                                value={formData.value}
                                onChange={handleChange}
                                required
                            />
                        </Form.Group>

                        <Form.Group controlId="formType">
                            <Form.Label>Type</Form.Label>
                            <Form.Control
                                as="select"
                                name="type"
                                value={formData.type}
                                onChange={handleChange}
                                required
                            >
                                <option value="text">Text</option>
                                <option value="number">Number</option>
                                <option value="date">Date</option>
                            </Form.Control>
                        </Form.Group>

                        <Form.Group controlId="formTooltip" style={{ height: '200px' }}>
                            <Form.Label>Tooltip</Form.Label>
                            <ReactQuill
                                value={formData.tooltip || ''}
                                style={{ height: '120px' }}
                                onChange={handleTooltip}
                                name="tooltip"
                                modules={{
                                    toolbar: [
                                        ['bold', 'italic', 'underline', 'strike'], // Formato básico
                                        ['list', 'bullet', 'indent', '-1', '+1'], // Listas
                                        ['link', 'image', 'video'], // Enlaces e imágenes
                                    ],
                                }}
                            />
                        </Form.Group>

                        <Form.Group controlId="formModal"
                                    style={{ height: '200px' }}>
                        <Form.Label>Modal</Form.Label>
                        <ReactQuill
                            value={formData.modal || ''}
                            style={{ height: '120px' }}
                            onChange={handleModal}
                            name="modal"
                            modules={{
                                toolbar: [
                                    ['bold', 'italic', 'underline', 'strike'], // Formato básico
                                    ['list', 'bullet', 'indent', '-1', '+1'], // Listas
                                    ['link', 'image', 'video'], // Enlaces e imágenes
                                ],
                            }}
                        />
                        </Form.Group>

                        <Form.Group controlId="formLink">
                            <Form.Label>Link</Form.Label>
                            <Form.Control
                                type="text"
                                name="link"
                                value={formData.link || ''}
                                onChange={handleChange}
                            />
                        </Form.Group>

                        <Button variant="primary" type="submit" className="mt-3">
                            Guardar Cambios
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default CreateForm;